/**
 * Meta keywords as one line for the single-line field on Web Store Settings:
 * keywords saved one per line (the old textarea) become comma-separated, so editing
 * them doesn't run two keywords together.
 *
 * It runs on every render of the field, so a value without line breaks comes back
 * exactly as typed: "silk, " must stay "silk, " while the seller types the next
 * keyword (PR #295 review R2-1). Only a value holding line breaks (one saved by the
 * old textarea; the field itself can't type one) is rewritten. Split / trim / join
 * rather than a regex, so long runs of spaces cost linear time (review R2-2).
 * @param {string} value the stored meta_keywords
 * @returns {string}
 */
export const keywordsOnOneLine = (value) => {
    const text = String(value ?? '');
    if (!text.includes('\n') && !text.includes('\r')) return text;
    return text
        .split(/\r\n|\r|\n/)
        .map(keyword => keyword.trim())
        .filter(Boolean)
        .join(', ');
};
